import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { DownArrowIcon } from "../../common/Icons";
import Spacer from "../../common/Spacer";
// import CustomRadioButton from "../../common/CustomRadioButton";

const MultiSelectDropdown = ({ prompt_text, options, value, onChange }) => {
  const [inputValue, setInputValue] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const containerRef = useRef(null);
  const textAreaRef = useRef(null); // Create a ref for the textarea

  useEffect(() => {
    setTextAreaValue(value);
  }, [value]);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectOption = (option) => {
    // Get the current textarea and cursor position
    const textArea = textAreaRef.current;
    const cursorPosition = textArea.selectionStart;

    // Insert the selected option at the cursor position
    const newText =
      textAreaValue.slice(0, cursorPosition) +
      option +
      " " +
      // "\n" +
      textAreaValue.slice(cursorPosition);

    setInputValue("");
    setTextAreaValue(newText);
    setIsDropdownOpen(false);

    if (onChange) onChange(newText);

    // Use setTimeout to reset the cursor position after state update
    setTimeout(() => {
      const newCursorPosition = cursorPosition + option.length + 1; // Adjust for inserted text and newline
      textArea.selectionStart = newCursorPosition;
      textArea.selectionEnd = newCursorPosition;
      textArea.focus();
    }, 0);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setIsDropdownOpen(true);
  };

  const handleTextAreaChange = (e) => {
    const text = e.target.value;
    setTextAreaValue(text);

    if (onChange) {
      onChange(text);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Add this to prevent bubbling
    return false; // Explicitly return false
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Add this to prevent bubbling
    return false; // Explicitly return false
  };

  return (
    <Container
      ref={containerRef}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {options.length > 0 && (
        <TextFieldContainer>
          <TextField
            type="text"
            placeholder="Select response"
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => setIsDropdownOpen(true)}
          />
          <ArrowIconWrapper onClick={() => setIsDropdownOpen((prev) => !prev)}>
            <DownArrowIcon />
          </ArrowIconWrapper>

          {isDropdownOpen && (
            <Dropdown>
              {options.map((option, index) => (
                <DropdownItem
                  key={index}
                  onClick={() => handleSelectOption(option)}
                >
                  <span>{option}</span>
                </DropdownItem>
              ))}
            </Dropdown>
          )}
        </TextFieldContainer>
      )}
      {options.length > 0 && <Spacer height="16px" />}
      <TextAreaWrapper
        ref={textAreaRef} // Assign the ref to the textarea
        value={textAreaValue}
        placeholder={prompt_text}
        onChange={handleTextAreaChange}
        rows={6}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      />
    </Container>
  );
};

export default MultiSelectDropdown;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TextFieldContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  font-size: 16px;

  &:focus-within {
    border-color: #004f96;
  }

  &:hover {
    cursor: pointer;
  }

  & > input {
    cursor: pointer;
  }
`;

const TextField = styled.input`
  flex-grow: 1;
  border: none;
  outline: none;
  font-size: 16px;
`;

const ArrowIconWrapper = styled.div`
  cursor: pointer;
  margin-left: 8px;
`;

const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
`;

const DropdownItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background: #f1f5f9;
  }
`;

// const CheckIconWrapper = styled.div`
//   color: #26a69a;
// `;

const TextAreaWrapper = styled.textarea`
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  font-size: 16px;
  resize: none;

  &:focus {
    outline: none;
    border-color: #004f96;
  }
`;
